import React from 'react'
import { Paperclip } from 'lucide-react'

const icon = props => <Paperclip size={20} {...props} />

export default icon
